import { Fab as MuiFab, useMediaQuery } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const Fab = styled(MuiFab)<any>(({ theme, device }) => ({
  '&:hover': {
    backgroundColor: '#fff',
    scale: '1.1',
  },
  '@keyframes hotspotAnimation': {
    '0%': {
      boxShadow: 'rgba(255, 255, 255, .3) 0px 0px 0px 0px',
    },
    '25%': {
      boxShadow: `rgba(255, 255, 255, .3) 0px 0px 0px ${
        device === 'mobile' ? '3' : '10'
      }px`,
    },
    '100%': {
      boxShadow: 'rgba(255, 255, 255, .3) 0px 0px 0px 0px',
    },
  },
  [theme.breakpoints.down('lg')]: {
    width: '14px',
    minHeight: 'auto',
    height: '14px',
    '&>svg': {
      fontSize: '0.6rem',
    },
  },
  animation: '2s ease infinite hotspotAnimation',
  backgroundColor: 'white',
  transition: 'all 0.2s ease-in-out',
}));

type PropsTypes = {
  onClick?: any;
};

export default function Interior360AnimationFab(props: PropsTypes) {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  const { onClick } = props;

  return (
    <Fab
      device={isMobile ? 'mobile' : 'desktop'}
      onClick={onClick}
      size="small"
    >
      <KeyboardArrowUpIcon fontSize="small" sx={{ color: '#000' }} />
    </Fab>
  );
}
